// import React from 'react';
// import Navbar from '../Navbar/navbar';
// import Footer from '../Footer/footer';
// import FooterDoodles from '../Footer/footerDoodles';
// import icons from '../../icons.config';

// const PrivacyPolicy = () => {

//   useEffect(() => {
//     const fetchPrivacyPolicy = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/privacypolicy/getPrivacyPolicy`
//         );
//         setPrivacyPolicy(response.data.privacy_policy); // Assuming API returns { content: "Your Privacy Policy text" }
//       } catch (error) {
//         console.error("Error fetching Privacy Policy:", error);
//       }
//     };

//     fetchPrivacyPolicy();
//   }, []);

//   const policySections = [
//     {
//       heading: '1. Introduction',
//       description: 'Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.',
//     },
//     {
//       heading: '2. Information We Collect',
//       description: 'We collect different types of information, including personal and non-personal data, to improve our services and user experience.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.',
//     },
//     {
//       heading: '3. How We Use Your Information',
//       description: 'The information collected is used to enhance our services, personalize your experience, and ensure compliance with legal obligations.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.',
//     },
//     {
//       heading: '4. Data Security',
//       description: 'We implement strong security measures to protect your data from unauthorized access, alteration, disclosure, or destruction.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.Welcome to our privacy policy. Your privacy is critically important to us, and we are committed to protecting your personal information.',
//     },
//     {
//       heading: '5. Contact Us',
//       description: 'If you have any questions about our privacy policy, feel free to contact us at support@example.com.',
//     },
//   ];

//   return (
//     <>
//       <Navbar />
//       <section className="flex flex-col justify-center items-center w-full h-full bg-tertiary pt-60 lg:pt-5 relative pb-0 overflow-hidden">
//         <div className="hidden lg:block relative lg:left-[45%] z-10">
//           <img src={icons.trendCircles} alt="Doodle Left" className="w-[70%]" />
//         </div>
//       </section>

//       <section className="bg-tertiary">
//         {/* Privacy Policy Title */}
//         <div className="flex justify-center items-center  relative bottom-20 lg:bottom-28">
//           <h1 className="text-primary1 font-poppins text-3xl font-extralight ">
//             PRIVACY POLICY
//           </h1>
//         </div>

//         {/* Policy Content */}
//         <div className="px-12 md:px-12 lg:px-24 xl:px-32 text-left z-20">
//           {policySections.map((section, index) => (
//             <div key={index} className="mb-6">
//               <h2 className="text-xl font-semibold text-secondary">{section.heading}</h2>
//               <p className="text-base text-gray-700 mt-2">{section.description}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       <FooterDoodles />
//       <Footer />
//     </>
//   );
// };

// export default PrivacyPolicy;
import React, { useEffect, useState } from 'react';
import { fetchPrivacyPolicy } from '../../Providers/staticFileProvider';
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/footer';
import FooterDoodles from '../Footer/footerDoodles';
import icons from '../../icons.config';
import axios from 'axios';

const PrivacyPolicy = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState("");

  useEffect(() => {
    const getPrivacyPolicy = async () => {
      const data = await fetchPrivacyPolicy();
      if (data) setPrivacyPolicy(data);
    };
    getPrivacyPolicy();
  }, []);

  return (
    <>
      <Navbar />
      <section className="flex flex-col justify-center items-center w-full h-full bg-tertiary pt-10 md:pt-3 lg:pt-0 lg:-mt-5 relative pb-0 overflow-hidden">
        <div className="lg:block relative left-[60%] md:left-[45%] lg:left-[45%] z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-[40%] md:w-[60%] lg:w-[70%]" />
        </div>
      </section>

      <section className="bg-tertiary">
        <div className="flex justify-center items-center relative bottom-12 md:bottom-14 lg:bottom-24">
          <h1 className="text-primary1 font-outfit text-2xl md:text-3xl lg:text-4xl font-light">
            PRIVACY POLICY
          </h1>
        </div>

        <div className="px-12 md:px-12 lg:px-24 xl:px-32 text-left z-20 pb-10 lg:-mt-10">
          {privacyPolicy ? (
            <p className="text-base text-gray-700 mt-2 whitespace-pre-line">{privacyPolicy}</p>
          ) : (
            <p className="text-gray-500">Loading privacy policy...</p>
          )}
        </div>
      </section>

      <FooterDoodles />
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
